import React, { useState } from "react";

const ROLE_COLORS = {
  administrator: "#4a5578",
  pokja: "#157a6e",
  internal: "#2e6c9e",
  external: "#b4762a",
};

const SHARED = [
  {
    title: "Masuk ke Akun",
    desc: "Halaman pertama yang Anda lihat setiap membuka SPEAK.",
    items: [
      { name: "Login", desc: "Memasukkan Anda ke akun dengan username dan kata sandi, lalu membawa Anda ke halaman profil." },
      { name: "Lupa Password?", desc: "Mengatur ulang kata sandi Anda sendiri hanya dengan memasukkan username — kata sandi akan diganti ke kata sandi bawaan yang bisa langsung dipakai untuk masuk." },
    ],
  },
  {
    title: "Notifikasi",
    desc: "Ikon lonceng di bagian atas halaman menampilkan pemberitahuan terbaru untuk akun Anda.",
    items: [
      { name: "Klik satu notifikasi", desc: "Menandai notifikasi tersebut sebagai sudah dibaca." },
      { name: "Tandai Semua Dibaca", desc: "Menandai seluruh notifikasi yang belum dibaca menjadi sudah dibaca sekaligus." },
    ],
  },
  {
    title: "Profil Saya",
    desc: "Menampilkan data rumah sakit yang tercatat di SPEAK — nama, alamat, direktur, dan narahubung.",
    items: [
      { name: "Edit", desc: "Membuka formulir untuk memperbarui data profil rumah sakit." },
    ],
  },
  {
    title: "Dokumen",
    desc: "Tempat melihat kembali seluruh dokumen bukti dukung yang pernah diunggah untuk penilaian akreditasi.",
    items: [
      { name: "Cari", desc: "Menampilkan daftar dokumen berdasarkan periode akreditasi dan bab yang dipilih." },
      { name: "Lihat Dokumen", desc: "Membuka atau mengunduh isi dokumen yang dipilih." },
    ],
  },
  {
    title: "Keluar",
    desc: "Mengakhiri sesi Anda dan kembali ke halaman login.",
    items: [
      { name: "Sign Out", desc: "Selalu gunakan tombol ini setelah selesai memakai SPEAK, terutama di komputer yang dipakai bersama." },
    ],
  },
];

const MATRIX = [
  { label: "Akreditasi (daftar kegiatan)", administrator: "Kelola", pokja: "Isi", internal: "Nilai", external: "Lihat" },
  { label: "Penilaian Mandiri (isi skor)", administrator: "—", pokja: "Isi", internal: "Nilai", external: "Lihat" },
  { label: "Dokumen & Forum", administrator: "Lihat", pokja: "Ya", internal: "Ya", external: "Lihat*" },
  { label: "Perencanaan Perbaikan (PPS)", administrator: "Lihat", pokja: "Kelola", internal: "Kelola", external: "Lihat" },
  { label: "Manajemen Risiko", administrator: "Kelola", pokja: "Isi", internal: "Isi", external: "—" },
  { label: "Pengguna, Peran & Data Master", administrator: "Kelola", pokja: "—", internal: "—", external: "—" },
  { label: "Dashboard ringkasan", administrator: "—", pokja: "—", internal: "Ya", external: "Segera hadir" },
];

const ROLES = [
  {
    key: "administrator",
    label: "Administrator",
    intro: "Sebagai Administrator, Anda mengatur siapa saja yang memakai SPEAK dan apa yang boleh mereka lakukan, memulai setiap periode penilaian akreditasi, serta menjaga data standar dan hasil penilaian tetap rapi. Anda sendiri tidak mengisi skor penilaian mandiri.",
    pages: [
      {
        name: "Akreditasi",
        hint: "daftar kegiatan penilaian",
        desc: "Daftar seluruh periode penilaian akreditasi yang pernah dan sedang berjalan di rumah sakit Anda. Dari sinilah setiap siklus akreditasi dimulai.",
        buttons: [
          { name: "Tambah Kegiatan Akreditasi", desc: "Memulai periode penilaian baru: memilih standar akreditasi yang dipakai dan menentukan tanggal pelaksanaannya." },
          { name: "Detail", desc: "Menampilkan ringkasan satu periode: standar yang dipakai, hasil, tanggal, dan status." },
          { name: "Edit", desc: "Mengubah tanggal atau standar dari periode yang sudah dibuat." },
          { name: "Import Self Assessment", desc: "Mengunggah satu file berisi hasil penilaian mandiri, agar tidak perlu dimasukkan satu per satu." },
          { name: "Sync Capaian Akreditasi", desc: "Menghitung ulang dan memperbarui hasil akhir akreditasi berdasarkan seluruh skor yang sudah masuk." },
          { name: "Export Score Bab", desc: "Mengunduh rekap skor tiap bab sebagai file yang bisa dicetak, lengkap dengan persentase kelengkapan penilaian." },
          { name: "Import Rekomendasi", desc: "Mengunggah rekomendasi perbaikan dari surveior, yang selanjutnya muncul di halaman Perencanaan Perbaikan Strategis." },
          { name: "Backfill Keterkaitan Dokumen", desc: "Tombol perbaikan untuk periode akreditasi lama: menghubungkan kembali dokumen yang sudah pernah diunggah dengan penilaian terkait. Aman dijalankan berulang kali, dan hanya diperlukan bila ada dokumen lama yang tampak tidak terhubung." },
        ],
      },
      {
        name: "Pengguna",
        hint: "akun & hak akses per bab",
        desc: "Mengelola siapa saja yang memiliki akun SPEAK untuk rumah sakit Anda.",
        buttons: [
          { name: "Tambah Pengguna", desc: "Membuat akun baru: nama, username, kata sandi awal, dan peran pengguna." },
          { name: "Detail", desc: "Melihat data lengkap seorang pengguna." },
          { name: "Ubah Pengguna", desc: "Mengubah data atau peran seorang pengguna." },
          { name: "Mapping Bab Pengguna", desc: "Menentukan bab-bab akreditasi yang boleh diisi oleh pengguna tertentu. Seorang anggota Kelompok Kerja atau Surveior Internal baru bisa mengisi skor pada suatu bab setelah diberi akses lewat menu ini." },
        ],
      },
      {
        name: "Peran & Hak Akses",
        hint: "Groups",
        desc: "Mengatur keempat peran di SPEAK beserta halaman yang bisa diakses masing-masing peran.",
        buttons: [
          { name: "Tambah Group", desc: "Membuat peran baru." },
          { name: "Edit", desc: "Mengubah nama peran atau hak aksesnya." },
          { name: "Maping Module", desc: "Menentukan halaman mana saja yang bisa dilihat dan dipakai oleh peran tersebut." },
          { name: "Detail Group", desc: "Melihat daftar halaman yang sudah diberikan ke suatu peran." },
        ],
      },
      {
        name: "Modul",
        hint: "daftar halaman sistem",
        desc: "Daftar seluruh halaman yang tersedia di SPEAK, yang kemudian dibagikan ke tiap peran lewat halaman Peran & Hak Akses.",
        buttons: [
          { name: "Tambah Modul", desc: "Mendaftarkan halaman baru ke dalam sistem." },
          { name: "Edit", desc: "Mengubah nama atau alamat dari halaman yang sudah terdaftar." },
        ],
      },
      {
        name: "Mapping Grup",
        hint: "pengaturan akses cepat",
        desc: "Cara cepat mengatur akses pengguna, peran, dan halaman sekaligus dalam satu tempat.",
        buttons: [
          { name: "Tambah Maping Group", desc: "Menambahkan satu pengaturan akses baru." },
          { name: "Edit", desc: "Mengubah pengaturan akses yang sudah ada." },
        ],
      },
      {
        name: "Kelompok Kerja",
        hint: "tim & anggotanya",
        desc: 'Berbeda dari peran "Kelompok Kerja", halaman ini mengatur tim kerja yang sesungguhnya — misalnya tim yang menangani bab tertentu — beserta anggotanya.',
        buttons: [
          { name: "Tambah Pokja", desc: "Membuat tim kerja baru." },
          { name: "Tambah Anggota", desc: "Memasukkan seorang pengguna ke dalam suatu tim kerja." },
          { name: "Edit", desc: "Mengubah nama atau data tim kerja." },
          { name: "Hapus", desc: "Menghapus tim kerja, setelah konfirmasi." },
          { name: "Lihat Anggota", desc: "Menampilkan daftar anggota dalam satu tim kerja." },
        ],
      },
      {
        name: "Data Standar, Bab, Elemen & Instrumen Akreditasi",
        hint: "referensi",
        desc: "Empat halaman referensi berisi seluruh standar, bab, elemen penilaian, dan instrumen akreditasi yang berlaku. Halaman ini bersifat lihat-saja; datanya diperbarui lewat pengunggahan file, bukan diketik satu per satu.",
        buttons: [
          { name: "Import", desc: "Mengunggah file untuk memperbarui atau menambah data standar, bab, elemen, atau instrumen akreditasi secara massal." },
        ],
      },
      {
        name: "Divisi Risiko",
        hint: "unit rumah sakit",
        desc: "Daftar unit atau divisi rumah sakit yang menjadi acuan pada modul Manajemen Risiko.",
        buttons: [
          { name: "Tambah Divisi", desc: "Menambahkan unit atau divisi baru." },
          { name: "Edit", desc: "Mengubah data divisi." },
          { name: "Hapus", desc: "Menghapus divisi, setelah konfirmasi." },
        ],
      },
    ],
  },
  {
    key: "pokja",
    label: "Kelompok Kerja",
    intro: "Sebagai anggota Kelompok Kerja (Pokja), Anda mengisi penilaian mandiri rumah sakit terhadap standar akreditasi, mengunggah bukti dukung, dan menindaklanjuti rekomendasi perbaikan.",
    pages: [
      {
        name: "Akreditasi",
        hint: "daftar kegiatan penilaian",
        desc: "Daftar periode penilaian akreditasi. Dari sini Anda masuk ke ruang kerja penilaian untuk periode yang sedang berjalan.",
        buttons: [
          { name: "Penilaian Mandiri", desc: "Membuka ruang kerja penilaian untuk periode tersebut, tempat Anda mengisi skor dan mengunggah bukti dukung." },
          { name: "Forum", desc: "Membuka ruang diskusi untuk periode akreditasi tersebut." },
          { name: "Perencanaan Perbaikan Strategis (PPS)", desc: "Membuka daftar rekomendasi perbaikan yang perlu ditindaklanjuti." },
          { name: "Export Score Bab", desc: "Mengunduh rekap skor tiap bab sebagai file yang bisa dicetak." },
        ],
      },
      {
        name: "Penilaian Mandiri",
        hint: "mengisi skor & bukti dukung",
        desc: "Halaman inti tempat penilaian mandiri dilakukan. Pilih bab, lalu standar, lalu elemen penilaian untuk mulai mengisi.",
        buttons: [
          { name: "Tambah Skor", desc: "Mencatat nilai penilaian mandiri untuk elemen yang sedang dibuka. Hanya bisa dipakai bila Anda sudah diberi akses ke bab tersebut oleh Administrator, dan penilaian belum dikunci." },
          { name: "Edit skor", desc: "Mengubah nilai yang sudah dimasukkan, selama penilaian belum dikunci." },
          { name: "Tambah Dokumen", desc: "Mengunggah dokumen bukti dukung untuk elemen yang sedang dibuka." },
          { name: "Hapus Dokumen", desc: "Menghapus dokumen yang sudah diunggah, setelah konfirmasi." },
          { name: "Lihat Keterkaitan Dokumen", desc: "Menampilkan bab dan elemen mana saja yang menggunakan dokumen tersebut." },
          { name: "Buka Dokumen", desc: "Membuka atau mengunduh isi dokumen." },
          { name: "Tambah Diskusi", desc: "Memulai percakapan terkait elemen tersebut; percakapan ini juga muncul di halaman Forum." },
          { name: "Submit", desc: "Mengunci seluruh skor Anda pada bab tersebut dan menyerahkannya untuk diperiksa oleh Surveior Internal. Setelah ini skor tidak bisa lagi diubah, kecuali dikembalikan oleh Surveior Internal." },
        ],
      },
      {
        name: "Forum",
        hint: "diskusi per elemen",
        desc: "Ruang diskusi per elemen penilaian, dipakai untuk berkomunikasi dengan Surveior Internal mengenai suatu elemen tertentu.",
        buttons: [
          { name: "Tambah Diskusi / Balas", desc: "Menambahkan komentar atau balasan pada elemen yang sedang dibahas." },
        ],
      },
      {
        name: "Perencanaan Perbaikan Strategis (PPS)",
        hint: "daftar rekomendasi",
        desc: "Daftar rekomendasi perbaikan yang diberikan surveior untuk periode akreditasi tertentu.",
        buttons: [
          { name: "Item PPS", desc: "Membuka rincian rencana perbaikan untuk satu rekomendasi." },
          { name: "Export Item PPS", desc: "Mengunduh daftar rencana perbaikan sebagai file Excel." },
          { name: "Export Dokumen", desc: "Mengunduh daftar dokumen bukti sebagai file Excel." },
        ],
        subgroups: [
          {
            label: "Item PPS",
            buttons: [
              { name: "Tambah Laporan", desc: "Menambahkan rencana perbaikan baru: langkah pemenuhan, cara pelaksanaan, target yang ingin dicapai, jangka waktu, penanggung jawab, dan kategorinya." },
              { name: "Detail", desc: "Melihat rincian lengkap satu rencana perbaikan." },
              { name: "Edit", desc: "Mengubah rencana perbaikan yang sudah dibuat." },
              { name: "Hapus", desc: "Menghapus rencana perbaikan." },
              { name: "Dokumen", desc: "Membuka daftar dokumen bukti untuk rencana perbaikan tersebut." },
            ],
          },
          {
            label: "Dokumen PPS",
            buttons: [
              { name: "Tambah Dokumen", desc: "Mengunggah dokumen bukti." },
              { name: "Lihat Dokumen", desc: "Membuka isi dokumen." },
              { name: "Hapus Dokumen", desc: "Menghapus dokumen yang sudah diunggah." },
            ],
          },
        ],
      },
      {
        name: "Kegiatan & Sasaran Risiko",
        hint: "titik awal manajemen risiko",
        desc: "Daftar kegiatan atau tujuan operasional yang akan dipantau risikonya.",
        buttons: [
          { name: "Tambah Kegiatan & Sasaran", desc: "Menambahkan kegiatan atau tujuan baru beserta penanggung jawabnya." },
          { name: "Detail Info", desc: "Membuka rincian pengelolaan risiko lengkap untuk kegiatan tersebut." },
          { name: "Edit", desc: "Mengubah data kegiatan." },
          { name: "Hapus", desc: "Menghapus kegiatan, setelah konfirmasi." },
        ],
      },
      {
        name: "Rincian Risiko",
        hint: "register, profil, penanganan, pemantauan",
        desc: "Setelah membuka satu kegiatan, halaman ini menampilkan seluruh proses pengelolaan risikonya dalam lima bagian.",
        subgroups: [
          { label: "1. Register Risiko", buttons: [{ name: "Tambah / Edit / Hapus", desc: "Mencatat, mengubah, atau menghapus risiko yang teridentifikasi untuk kegiatan tersebut." }] },
          { label: "2. Profil Risiko", buttons: [{ name: "Tambah / Edit / Hapus", desc: "Mencatat analisis penyebab dan status pengendalian untuk setiap risiko." }] },
          { label: "3. Rencana Penanganan Risiko", buttons: [{ name: "Tambah / Edit / Hapus", desc: "Menyusun rencana untuk menangani atau mengurangi suatu risiko." }] },
          { label: "4. Pemantauan Pengendalian Risiko", buttons: [{ name: "Tambah / Edit / Hapus", desc: "Mencatat hasil pemantauan berkala terhadap penanganan risiko." }] },
          { label: "5. Laporan Pemantauan", buttons: [{ name: "Edit", desc: "Melengkapi ringkasan hasil pemantauan — tindakan yang diambil, tingkat risiko, kecenderungan, dan efektivitasnya. Bagian ini hanya bisa diubah, karena isinya berasal dari data pemantauan yang sudah ada." }] },
        ],
      },
      {
        name: "Peta Panas Risiko",
        hint: "gambaran visual tingkat risiko",
        desc: "Menampilkan gambaran visual tingkat risiko rumah sakit dalam bentuk peta panas, berdasarkan periode dan skema pembobotan yang dipilih.",
        buttons: [
          { name: "Export to Excel", desc: "Mengunduh daftar risiko yang sedang ditampilkan sebagai file Excel." },
        ],
      },
    ],
  },
  {
    key: "internal",
    label: "Surveior Internal",
    intro: "Sebagai Surveior Internal, tugas Anda adalah memeriksa dan memberi penilaian independen atas hasil penilaian mandiri yang sudah diisi oleh Kelompok Kerja, sebelum data tersebut dianggap final.",
    pages: [
      {
        name: "Akreditasi",
        hint: "daftar kegiatan penilaian",
        desc: "Daftar periode penilaian akreditasi, sama seperti yang dilihat Kelompok Kerja.",
        buttons: [
          { name: "Penilaian Mandiri", desc: "Membuka ruang kerja penilaian untuk periode tersebut, tempat Anda memeriksa dan menilai." },
          { name: "Forum", desc: "Membuka ruang diskusi untuk periode akreditasi tersebut." },
          { name: "Perencanaan Perbaikan Strategis (PPS)", desc: "Membuka daftar rekomendasi perbaikan." },
          { name: "Export Score Bab", desc: "Mengunduh rekap skor tiap bab sebagai file yang bisa dicetak." },
        ],
      },
      {
        name: "Penilaian Mandiri",
        hint: "menilai & membuka kunci",
        desc: "Ruang kerja yang sama dengan Kelompok Kerja, dengan tambahan kendali untuk memeriksa dan mengunci hasil penilaian.",
        buttons: [
          { name: "Set To TDD", desc: 'Menandai seluruh elemen dalam satu bab sebagai "Tidak Dapat Dinilai", untuk bab yang memang tidak berlaku bagi rumah sakit tersebut. Hanya bisa dilakukan sebelum bab itu diserahkan oleh Kelompok Kerja.' },
          { name: "Tambah Skor", desc: "Mencatat nilai penilaian independen Anda untuk suatu elemen. Baru bisa dipakai setelah Kelompok Kerja menyerahkan bab tersebut. Nilai Anda disimpan terpisah dan ditampilkan berdampingan dengan nilai Kelompok Kerja, lengkap dengan riwayatnya." },
          { name: "Rollback", desc: "Membuka kembali kunci pada bab yang sudah diserahkan, sehingga Kelompok Kerja dapat memperbaiki isiannya." },
          { name: "Tambah / Hapus / Buka Dokumen, Tambah Diskusi", desc: "Berfungsi sama seperti pada Kelompok Kerja." },
        ],
      },
      {
        name: "Forum",
        hint: "diskusi per elemen",
        desc: "Ruang diskusi yang sama dengan Kelompok Kerja, untuk membahas elemen penilaian tertentu.",
        buttons: [],
      },
      {
        name: "Perencanaan Perbaikan Strategis (PPS)",
        hint: "kelola penuh",
        desc: "Anda memiliki hak yang sama dengan Kelompok Kerja untuk mengelola rekomendasi, rencana perbaikan, dan dokumen buktinya — termasuk menambah, mengubah, dan menghapus.",
        buttons: [],
      },
      {
        name: "Manajemen Risiko",
        hint: "kegiatan, register, peta panas",
        desc: "Anda memiliki akses yang sama dengan Kelompok Kerja pada Kegiatan & Sasaran Risiko, Rincian Risiko, dan Peta Panas Risiko. Halaman Divisi Risiko tetap khusus untuk Administrator.",
        buttons: [],
      },
      {
        name: "Dashboard Surveior Internal",
        hint: "ringkasan visual",
        desc: "Menampilkan ringkasan visual mengenai progres penilaian. Halaman ini hanya untuk dilihat dan tidak memiliki tombol aksi.",
        buttons: [],
      },
    ],
  },
  {
    key: "external",
    label: "Surveior External",
    intro: "Sebagai Surveior External, Anda meninjau hasil akreditasi rumah sakit dari luar. Sebagian besar halaman yang Anda akses bersifat lihat-saja, tanpa kemampuan mengubah data.",
    pages: [
      {
        name: "Akreditasi",
        hint: "daftar kegiatan penilaian",
        desc: "Daftar periode penilaian akreditasi.",
        buttons: [
          { name: "Detail", desc: "Menampilkan ringkasan satu periode: standar yang dipakai, hasil, tanggal, dan status." },
          { name: "Perencanaan Perbaikan Strategis (PPS)", desc: "Membuka daftar rekomendasi perbaikan untuk periode tersebut." },
        ],
        note: "Tombol Edit, Import, Sync, dan Export Score Bab tidak tersedia untuk peran ini.",
      },
      {
        name: "Penilaian Mandiri",
        hint: "lihat saja",
        desc: "Menampilkan skor dan dokumen yang sudah diisi oleh Kelompok Kerja dan Surveior Internal. Tidak ada tombol untuk menambah skor, dokumen, atau diskusi — halaman ini murni untuk peninjauan.",
        buttons: [],
      },
      {
        name: "Perencanaan Perbaikan Strategis (PPS)",
        hint: "lihat saja",
        desc: "Anda dapat melihat daftar rekomendasi, rencana perbaikan, dan dokumen buktinya. Tombol tambah, ubah, hapus, dan ekspor tidak tersedia untuk peran ini.",
        buttons: [],
      },
      {
        name: "Dashboard Surveior External",
        hint: "sedang dikembangkan",
        desc: "Halaman ini masih dalam tahap pengembangan dan belum menampilkan data. Untuk saat ini, gunakan halaman Akreditasi dan Perencanaan Perbaikan Strategis untuk meninjau hasil penilaian.",
        buttons: [],
      },
    ],
  },
];

const PanduanPage = () => {
  const [activeRole, setActiveRole] = useState("administrator");
  const [query, setQuery] = useState("");

  const q = query.trim().toLowerCase();
  const searching = q.length > 0;

  const matchesQuery = (text) => text.toLowerCase().includes(q);

  const pageMatches = (page) => {
    if (!searching) return true;
    if (matchesQuery(page.name) || matchesQuery(page.desc)) return true;
    if (page.buttons?.some((b) => matchesQuery(b.name) || matchesQuery(b.desc))) return true;
    if (page.subgroups?.some((g) => g.buttons.some((b) => matchesQuery(b.name) || matchesQuery(b.desc)))) return true;
    return false;
  };

  const rolesToShow = searching ? ROLES : ROLES.filter((r) => r.key === activeRole);

  return (
    <>
      <style>{`
        .panduan-page .role-pill {
          border: 1px solid #dcdcdc;
          background: #fff;
          border-radius: 999px;
          padding: 6px 16px;
          font-size: 13.5px;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          margin: 0 8px 8px 0;
          cursor: pointer;
          color: #555;
        }
        .panduan-page .role-pill .dot {
          width: 8px; height: 8px; border-radius: 50%; flex: none;
        }
        .panduan-page .role-pill.active {
          color: #fff;
          border-color: transparent;
        }
        .panduan-page .role-tag {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-size: 11.5px;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          font-weight: 700;
          padding: 4px 10px 4px 8px;
          border-radius: 999px;
          margin-bottom: 10px;
        }
        .panduan-page .page-card {
          border: 1px solid #e4e4e4;
          border-radius: 10px;
          margin-bottom: 12px;
          overflow: hidden;
          background: #fff;
        }
        .panduan-page .page-card summary {
          list-style: none;
          cursor: pointer;
          padding: 14px 18px;
          font-weight: 600;
          font-size: 15px;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .panduan-page .page-card summary::-webkit-details-marker { display: none; }
        .panduan-page .page-card summary .hint {
          font-weight: 400;
          color: #9a9a9a;
          font-size: 12.5px;
          margin-left: auto;
        }
        .panduan-page .page-body { padding: 0 18px 16px 18px; }
        .panduan-page .page-body p.desc { color: #6b6b6b; font-size: 14px; margin: 0 0 10px; }
        .panduan-page .btn-row { border-top: 1px solid #f0f0f0; padding: 9px 0; }
        .panduan-page .btn-row:first-child { border-top: none; }
        .panduan-page .btn-row .name { font-weight: 600; font-size: 13.5px; }
        .panduan-page .btn-row .desc { color: #6b6b6b; font-size: 13.5px; margin: 2px 0 0; }
        .panduan-page .subgroup-label {
          font-size: 12px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          color: #9a9a9a;
          margin: 14px 0 4px;
        }
        .panduan-page .shared-card {
          border: 1px solid #e4e4e4;
          border-radius: 10px;
          padding: 16px 18px;
          height: 100%;
          background: #fff;
        }
        .panduan-page .shared-card h4 { font-size: 15px; font-weight: 600; margin: 0 0 6px; }
        .panduan-page .shared-card p.desc { color: #6b6b6b; font-size: 13.5px; margin: 0 0 8px; }
        .panduan-page table.matrix th, .panduan-page table.matrix td {
          vertical-align: middle;
          font-size: 13.5px;
        }
        .panduan-page table.matrix td:not(:first-child),
        .panduan-page table.matrix th:not(:first-child) { text-align: center; }
      `}</style>

      <div className="panduan-page content d-flex flex-column flex-column-fluid" id="kt_content">
        <div className="toolbar" id="kt_toolbar">
          <div id="kt_toolbar_container" className="container-fluid d-flex flex-stack">
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                Panduan Pengguna
                <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                <small className="text-muted fs-7 fw-bold my-1 ms-1">#SPEAK_VERSI_RS</small>
              </h1>
            </div>
          </div>
        </div>

        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div id="kt_content_container" className="container-xxl">
            <div className="row gy-5 g-xl-8">
              <div className="col-xl-12">
                <div className="card mb-5">
                  <div className="card-body">
                    <p className="text-muted mb-4">
                      SPEAK adalah aplikasi tempat rumah sakit Anda menjalankan penilaian akreditasi: mengisi
                      penilaian mandiri, mengunggah bukti dukung, menindaklanjuti rekomendasi perbaikan, dan
                      memantau risiko. Tampilan yang Anda lihat berbeda-beda tergantung peran Anda. Gunakan kotak
                      pencarian atau pilih peran Anda di bawah untuk melihat halaman dan tombol yang tersedia.
                    </p>
                    <input
                      type="text"
                      className="form-control mb-4"
                      placeholder='Cari halaman atau tombol, mis. "submit", "dokumen", "skor"…'
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                    />

                    {!searching && (
                      <>
                        <h5 className="mb-3">Ringkasan: Siapa Bisa Apa</h5>
                        <div className="table-responsive mb-6">
                          <table className="table matrix table-bordered">
                            <thead>
                              <tr>
                                <th>Halaman</th>
                                <th style={{ color: ROLE_COLORS.administrator }}>Administrator</th>
                                <th style={{ color: ROLE_COLORS.pokja }}>Kelompok Kerja</th>
                                <th style={{ color: ROLE_COLORS.internal }}>Surveior Internal</th>
                                <th style={{ color: ROLE_COLORS.external }}>Surveior External</th>
                              </tr>
                            </thead>
                            <tbody>
                              {MATRIX.map((row) => (
                                <tr key={row.label}>
                                  <td>{row.label}</td>
                                  <td>{row.administrator}</td>
                                  <td>{row.pokja}</td>
                                  <td>{row.internal}</td>
                                  <td>{row.external}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <p className="text-muted fs-8">*Surveior External tidak memiliki akses ke Forum diskusi.</p>
                      </>
                    )}
                  </div>
                </div>

                {!searching && (
                  <div className="card mb-5">
                    <div className="card-body">
                      <h5 className="mb-1">Untuk Semua Pengguna</h5>
                      <p className="text-muted mb-4">
                        Fitur-fitur ini bekerja sama untuk keempat peran, di luar halaman khusus peran di bawahnya.
                      </p>
                      <div className="row g-4">
                        {SHARED.map((card) => (
                          <div className="col-md-4 col-sm-6" key={card.title}>
                            <div className="shared-card">
                              <h4>{card.title}</h4>
                              <p className="desc">{card.desc}</p>
                              {card.items.map((it) => (
                                <div className="btn-row" key={it.name}>
                                  <div className="name">{it.name}</div>
                                  <p className="desc">{it.desc}</p>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                <div className="card">
                  <div className="card-body">
                    {!searching && (
                      <div className="mb-4">
                        {ROLES.map((r) => (
                          <span
                            key={r.key}
                            className={`role-pill${activeRole === r.key ? " active" : ""}`}
                            style={activeRole === r.key ? { background: ROLE_COLORS[r.key] } : {}}
                            onClick={() => setActiveRole(r.key)}
                          >
                            <span className="dot" style={{ background: ROLE_COLORS[r.key] }} />
                            {r.label}
                          </span>
                        ))}
                      </div>
                    )}

                    {rolesToShow.map((role) => {
                      const visiblePages = role.pages.filter(pageMatches);
                      if (searching && visiblePages.length === 0) return null;
                      return (
                        <div key={role.key} className="mb-6">
                          {searching && (
                            <span
                              className="role-tag"
                              style={{ background: `${ROLE_COLORS[role.key]}22`, color: ROLE_COLORS[role.key] }}
                            >
                              <span className="dot" style={{ width: 7, height: 7, borderRadius: "50%", background: ROLE_COLORS[role.key] }} />
                              {role.label}
                            </span>
                          )}
                          {!searching && <p className="text-muted mb-4">{role.intro}</p>}

                          {visiblePages.map((page) => (
                            <details className="page-card" key={page.name} open={searching}>
                              <summary>
                                {page.name}
                                <span className="hint">{page.hint}</span>
                              </summary>
                              <div className="page-body">
                                <p className="desc">{page.desc}</p>
                                {page.buttons?.map((b) => (
                                  <div className="btn-row" key={b.name}>
                                    <div className="name">{b.name}</div>
                                    <p className="desc">{b.desc}</p>
                                  </div>
                                ))}
                                {page.subgroups?.map((g) => (
                                  <div key={g.label}>
                                    <p className="subgroup-label">{g.label}</p>
                                    {g.buttons.map((b) => (
                                      <div className="btn-row" key={b.name}>
                                        <div className="name">{b.name}</div>
                                        <p className="desc">{b.desc}</p>
                                      </div>
                                    ))}
                                  </div>
                                ))}
                                {page.note && <p className="text-muted fs-8 mt-2 mb-0">{page.note}</p>}
                              </div>
                            </details>
                          ))}
                        </div>
                      );
                    })}

                    {searching && rolesToShow.every((role) => role.pages.filter(pageMatches).length === 0) && (
                      <p className="text-muted">Tidak ada halaman atau tombol yang cocok dengan pencarian Anda.</p>
                    )}
                  </div>
                </div>

                <p className="text-muted fs-8 mt-4">
                  Panduan ini menjelaskan fungsi setiap halaman dan tombol di SPEAK berdasarkan tampilan yang berlaku
                  saat ini. Jika Anda tidak melihat sebuah tombol yang disebutkan di sini, kemungkinan akun Anda
                  belum diberi akses ke halaman atau bab terkait — hubungi Administrator rumah sakit Anda.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PanduanPage;
